const comments = [
  {
    name: '漫画迷小K',
    avatar: 'K',
    rating: 5,
    text: '布丁漫画下拉式阅读真的太赞了！以前看漫画一话一话点"下一页"点到手酸，现在直接往下滑就行，布丁漫画全集从第一话到最新话一气呵成，追漫效率翻倍。',
    date: '3天前',
    tag: '资深读者',
  },
  {
    name: '追更少女',
    avatar: '更',
    rating: 5,
    text: '布丁漫画网是我用过最舒服的漫画阅读平台，布丁漫画连续阅读模式特别适合通勤路上用手机看。韩漫、日漫资源很全，而且布丁漫画下拉式免费看，强烈推荐！',
    date: '5天前',
    tag: '韩漫爱好者',
  },
  {
    name: '夜读达人',
    avatar: '夜',
    rating: 5,
    text: '每天晚上睡前刷几话布丁漫画全集已经成为习惯。下拉式阅读的流畅度真的没话说，加载快，画质清晰，而且更新很及时，热门连载基本当天就能看到最新话。',
    date: '1周前',
    tag: '日漫老粉',
  },
  {
    name: '漫画编辑老张',
    avatar: '张',
    rating: 5,
    text: '作为漫画行业从业者，布丁漫画网的下拉式阅读技术确实领先。对读者来说体验极佳，对创作者来说也能更好地呈现分镜节奏。布丁漫画连续阅读是漫画阅读的未来方向。',
    date: '2周前',
    tag: '行业人士',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            读者评价
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            读者好评
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            来自布丁漫画网真实读者的使用评价和推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-7 cursor-default"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-11 h-11 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-semibold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-base font-semibold text-foreground-900">{comment.name}</h3>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {comment.tag}
                    </span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-1">
                    {Array.from({ length: comment.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm text-primary-500"></i>
                    ))}
                  </div>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{comment.date}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}